import React, { useState } from 'react';
import './CreateGroupModal.css';

function CreateGroupModal({ isOpen, onClose, onCreateGroup, onGroupCreated }) {
  const [name, setName] = useState('');
  const [context, setContext] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setError('Group name is required');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      const newGroup = await onCreateGroup(name.trim(), context.trim() || null);
      // Reset form
      setName('');
      setContext('');
      onClose();
      // Redirect to the new group
      if (newGroup && onGroupCreated) {
        onGroupCreated(newGroup.id);
      }
    } catch (err) {
      setError(err.message || 'Failed to create group');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setName('');
    setContext('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="create-group-overlay" onClick={handleClose}>
      <div className="create-group-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Create Group</h2>

        <form onSubmit={handleSubmit}>
          <div className="create-group-field">
            <label htmlFor="group-name">Name</label>
            <input
              id="group-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter group name..."
            />
          </div>

          <div className="create-group-field">
            <label htmlFor="group-context">Context <span className="create-group-optional">(optional)</span></label>
            <textarea
              id="group-context"
              value={context}
              onChange={(e) => setContext(e.target.value)}
              placeholder="Describe this group's purpose... e.g., 'Major donor prospects for our new building campaign' or 'Board members to cultivate for annual fund'"
              rows={3}
            />
          </div>

          {error && <div className="create-group-error">{error}</div>}

          <div className="create-group-actions">
            <button
              type="button"
              className="create-group-cancel"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="create-group-submit"
              disabled={isSubmitting || !name.trim()}
            >
              {isSubmitting ? 'Creating...' : 'Create'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateGroupModal;
